// personalised-user-state.js
// Single source of truth for reco-user detection on v2 personalised pages.
//
// Loaded as a synchronous (non-defer) script early in both
// page.personalised-review-v2.liquid and page.personalised-library-v2.liquid,
// before any inline detection scripts or deferred modules execute.
//
// Sets window.personalised.userState once per page load.
//
// hasReco is the sole signal used by v2 pages to distinguish reco users
// from non-reco users. It is true only when vitable_recommended_products
// exists in localStorage — meaning the backend has returned an active
// recommendation for this browser session.
//
// vitable_latest_quiz_date is NOT used here: it can be present for users
// who took the quiz a long time ago with no current recommendation, which
// would incorrectly show reco-specific UI. vitable_recommended_products is
// populated only when recommendation data is actually available.

(function () {
  'use strict';

  window.personalised = window.personalised || {};

  var hasReco = false;
  try {
    hasReco = !!localStorage.getItem('vitable_recommended_products');
  } catch (e) {
    // localStorage blocked (e.g. private browsing with strict settings) — treat as no reco
  }

  window.personalised.userState = {
    hasReco: hasReco
  };
}());
